module.exports = __webpack_public_path__ + "img/info-icon-square.ad5179e5.svg";